export default (array) => array[0];
